import { useFeatureFlag } from "@/contexts/FeatureFlagContext"

// Staging is conversation-scoped storage (see AgentChatContext.attachFile), so
// it needs a persisted conversation to scope to — CHAT_HISTORY is an implicit
// prerequisite for CHAT_FILE_UPLOAD, not just a related feature. Shared by the
// attach button and the staged-files load so the two can't drift: the backend
// rejects every files route with 403 while CHAT_FILE_UPLOAD is off.
export const useChatFileUploadEnabled = (): boolean => {
  const chatFileUpload = useFeatureFlag("CHAT_FILE_UPLOAD")
  const chatHistory = useFeatureFlag("CHAT_HISTORY")
  return chatFileUpload && chatHistory
}
